import { render, staticRenderFns } from "./WarningsView.vue?vue&type=template&id=06202a8e&scoped=true&"
import script from "./WarningsView.vue?vue&type=script&lang=js&"
export * from "./WarningsView.vue?vue&type=script&lang=js&"
import style0 from "./WarningsView.vue?vue&type=style&index=0&id=06202a8e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06202a8e",
  null
  
)

/* custom blocks */
import block0 from "./WarningsView.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports